import store from "../store/store";
import pWaitFor from "p-wait-for";
import locals from './localStorage';
import {formatLFM} from "../Contacts/ContactFormat";
import {getCurrentFirmId, getCurrentUserId} from "./picos/currentLogin";
import {setFaroUser} from "./faro";
import {globalAbortSignal} from "./picos/abortController";
import {startRecording} from './sessionReplay';

/**
 * Should we cancel the loop?
 */
let canceled = false;

/**
 * Check to see if all necessary identification information is present at this moment.
 */
function doCheck() {
	// See what information is available.
	const firmId = getCurrentFirmId() || locals.getString(locals.USER_FIRM_ID, null);
	if (!firmId) return false;

	const userId = getCurrentUserId() || locals.getString(locals.USER_FIRM_ID, null);
	if (!userId) return false;

	const firm = store.getState().firms.get(firmId);
	if (!firm) return false;

	const user = store.getState().users.get(userId);
	if (!user) return false;

	const contact = store.getState().contacts.get(user.contactId);
	if (!contact) return false;

	const name = formatLFM(contact);
	if (!name) return false;

	return {firmId, userId, name, email: user.email};
}

/**
 * If we have the information needed to initialize and identify the user, do it.
 */
export function setLoggingUser() {
	// Wait until we have all the information we require
	pWaitFor(() => !canceled && !!doCheck(), {interval: 1000, signal: globalAbortSignal})
		.then(() => {
			const checkResults = doCheck();
			if (checkResults) {
				const {firmId, userId, name, email} = checkResults;

				setFaroUser(userId, firmId);
			startRecording(userId, firmId);
			}
		});
}